import { loginMethods } from '@/_redesign/modules/Profile/modules/LoginMethods/locale';

import enProfile from './en.profile.json';

export const profile = {
  en: {
    ...enProfile,
    ...loginMethods.en,
  },
};
